import {
  KoForm,
  KoFormBuilder,
  KoInput,
  KoSelect
} from 'packages';

function CollectionCrud({ form, handleFinish, services = [], endpoints = [] }) {
  const ServiceWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select service' options={services} allowClear />
  );

  const EndpointsWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select endpoints' options={endpoints} mode='multiple' allowClear />
  );

  const meta = {
    columns: 4,
    formItemLayout: null,
    colon: true,
    fields: [
      { key: 'name', label: 'Collection Name', colSpan: 2, widget: KoInput, required: true, widgetProps: { placeholder: 'e.g. User CRUD Tests' } },
      { key: 'version', label: 'Version', colSpan: 1, widget: KoInput, widgetProps: { placeholder: 'v1.0' } },
      { key: 'service', label: 'Service', colSpan: 1, widget: ServiceWidget, forwardRef: true },
      { key: 'endpoints', label: 'Endpoints', colSpan: 4, widget: EndpointsWidget, forwardRef: true },
      { key: 'description', label: 'Description', colSpan: 4, widget: KoInput.TextArea, widgetProps: { rows: 3, placeholder: 'Collection description...' } }
    ]
  };

  return (
    <KoForm form={form} layout='vertical' onFinish={handleFinish}>
      <KoFormBuilder form={form} meta={meta} />
    </KoForm>
  );
}

export default CollectionCrud;
